import * as ReactService from "@intech/react-service";
import { HeaderInfoRendEntidade } from "../entidades/HeaderInfoRendEntidade";

class InfoRend extends ReactService.BaseService {
  constructor() {
    super("InfoRend");
  }

  Relatorio = (referencia: number, enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `Relatorio/${referencia}/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

  BuscarInformes = () =>
    this.CreateRequest<HeaderInfoRendEntidade[]>(ReactService.RequestType.GET, `BuscarInformes`);

  BuscarPorOid = (oid: number) =>
    this.CreateRequest<HeaderInfoRendEntidade>(ReactService.RequestType.GET, `BuscarPorOid/${oid}`);

}

export const InfoRendService = new InfoRend();
